var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag3Dots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3345 51.9991H14.6417C6.67338 51.9991 0.560375 49.1183 2.29675 37.5236L4.31856 21.8101C5.38893 16.0247 9.07577 13.8105 12.3107 13.8105H38.7607C42.0432 13.8105 45.5159 16.1914 46.7528 21.8101L48.7746 37.5236C50.2493 47.8088 44.3028 51.9991 36.3345 51.9991Z",
    stroke: "#C1CAE1",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.693 13.2376C36.693 7.03131 31.6665 2.0001 25.466 2.0001V2.0001C22.4802 1.98744 19.6123 3.16579 17.4965 5.27461C15.3807 7.38343 14.1914 10.249 14.1914 13.2376H14.1914",
    stroke: "#C1CAE1",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1745 24.9482H33.0556",
    stroke: "#C1CAE1",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0144 24.9482H17.8955",
    stroke: "#C1CAE1",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48.5C61 55.405 55.4037 61 48.5 61C41.5963 61 36 55.405 36 48.5C36 41.5975 41.5963 36 48.5 36C55.4037 36 61 41.5975 61 48.5Z",
    fill: "#E8EAF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9037 47.0039C42.0775 47.0039 41.4062 47.6752 41.4062 48.4989C41.4062 49.3239 42.0775 49.9964 42.9037 49.9964C43.73 49.9964 44.4012 49.3239 44.4012 48.4989C44.4012 47.6752 43.73 47.0039 42.9037 47.0039Z",
    fill: "#737FA4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M48.5014 47.0039C47.6752 47.0039 47.0039 47.6752 47.0039 48.4989C47.0039 49.3239 47.6752 49.9964 48.5014 49.9964C49.3277 49.9964 49.9989 49.3239 49.9989 48.4989C49.9989 47.6752 49.3277 47.0039 48.5014 47.0039Z",
    fill: "#737FA4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.0991 47.0039C53.2728 47.0039 52.6016 47.6752 52.6016 48.4989C52.6016 49.3239 53.2728 49.9964 54.0991 49.9964C54.9253 49.9964 55.5966 49.3239 55.5966 48.4989C55.5966 47.6752 54.9253 47.0039 54.0991 47.0039Z",
    fill: "#737FA4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag3Dots);
export default __webpack_public_path__ + "static/media/shopping-bag-3-dots.35e7ca97.svg";
export { ForwardRef as ReactComponent };